import { render } from "./HomeNewsArticle.vue?vue&type=template&id=92326b2e&scoped=true"
import script from "./HomeNewsArticle.vue?vue&type=script&lang=js"
export * from "./HomeNewsArticle.vue?vue&type=script&lang=js"

import "./HomeNewsArticle.vue?vue&type=style&index=0&id=92326b2e&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-92326b2e"]])

export default __exports__